import { currentPassword, newPassword, newPasswordConfirm } from 'config/inputs';

const changePasswordFormConfig = {
  inputsById: [
    'currentPassword', 'newPwd', 'newPwdConfirm'
  ],

  inputsByHash: {
    currentPassword: currentPassword,
    newPwd: newPassword,
    newPwdConfirm: newPasswordConfirm,
  }
}

export default changePasswordFormConfig;